/** * * Asynchronously loads the component for
BannerManagement
* */ import { lazyLoad } from 'utils/loadable';
export const BannerManagement = lazyLoad(() => import('./index'));
